import * as React from 'react';
import { useParams } from 'react-router-dom';
import { validate as isUuid } from 'uuid';

// import { previewEventVar } from '@context';

export function MyEventDetailPage() {
  const { eventId = null } = useParams();

  React.useEffect(() => {
    if (isUuid(eventId ?? '') || eventId === null) {
      // not more needed since now directly handled in the dialog to open the preview with useParams(), but we keep it just in case
      // previewEventVar(eventId);
    }
  }, [eventId]);

  return null;
}
